import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { physioMeMobileBreakpoint, physioMeTabletBreakpoint, row, stack } from "@ui/style";

export const EmptyContainer = styled.div`
	display: grid;
	place-items: center;
`;

export const TabContainer = styled.div`
	padding-top: 24px;
`;

export const TabHeader = styled.div`
	${row(undefined, "spacebetween", "flexstart")};

	@media ${physioMeTabletBreakpoint} {
		padding: 0 16px;
	}
`;

export const Layout = styled(motion.div)`
	padding-top: 24px;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
	grid-template-rows: min-content;
	grid-gap: 24px 32px;

	@media ${physioMeTabletBreakpoint} {
		padding: 16px;
		grid-gap: 16px 24px;
	}
	@media ${physioMeMobileBreakpoint} {
		grid-template-columns: 1fr;
	}
`;

export const CardWrapper = styled(motion.div)`
	${stack(undefined, "flexstart", "stretch")}
`;
